module.exports = __webpack_public_path__ + "img/3.3bd953e0.png";